import { ConsentLevel, useCookieConsent } from 'db-npm-e4sc-rd-ui';
import * as React from 'react';
import { runInlineScript } from '../../shared/utils/runInlineScript';

type CustomInsertHtmlProps = {
  fields: any;
  params: any;
};

const CustomInsertHtml: React.FC<CustomInsertHtmlProps> = ({ fields = {}, params }) => {
  const cookieConsent = useCookieConsent();
  const consentLevels = cookieConsent.getConsentLevels();
  const render = params && params.position;
  const renderScript = render && params.position === 'Footer';

  React.useEffect(() => {
    if (!renderScript) {
      return;
    }
    if (cookieConsent.isAllowed(ConsentLevel.Statistics)) {
      runInlineScript(fields['Script Analytical Cookie Accept']?.value);
    }
    if (cookieConsent.isAllowed(ConsentLevel.Marketing)) {
      runInlineScript(fields['Script Marketing Cookie Accept']?.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(consentLevels)]);

  if (!render) {
    return null;
  }

  const htmlContent = fields[params.position + ' HTML']?.value || '';

  return <span dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default CustomInsertHtml;
